<template>
	<div v-if="initialized">
		<custom-scrollbar v-if="accountActivity.length > 0" v-on:ps-y-reach-end="handleScrollEnd">
			<div class="timeline-wrapper">
				<ul class="timeline">
					<li class="timeline-item" v-for="(activity, index) in accountActivity" :key="index">
						<div class="timeline-item-bullet">
							<b-icon icon="dot-circle" :type="activity.class" />
						</div>
						<div class="timeline-item-text">
							<p>{{ activity.message }}</p>
							<div class="timeline-item-time">{{ activity.datetime }}</div>
						</div>
					</li>
				</ul>
			</div>
		</custom-scrollbar>
		<b-message v-if="!loading && accountActivity.length === 0"
		           type="is-info">
			No recent activity
		</b-message>
		<div class="has-text-centered">
			<b-icon v-if="loading"
			        pack="fas"
			        icon="sync-alt"
			        custom-class="fa-spin">
			</b-icon>
		</div>
	</div>
</template>

<script>
import { ACTIVITY_GET } from '../../store/actions/activity'
import CustomScrollbar from '../Elements/CustomScrollbar'

export default {

  data () {
    return {
      initialized: false,
      loading: true,
      accountActivity: [],
      page: 0,
      perPage: 15,
      hasMore: false
    }
  },

  props: {
    account: {
      type: Object
    },
    scrollActive: {
      type: Boolean,
      default: true
    }
  },

  components: {
    CustomScrollbar
  },

  created () {
    this.getActivity()
  },

  methods: {
    handleScrollEnd () {
      if (!this.loading && this.hasMore && this.scrollActive) {
        this.getActivity()
      }
    },

    getActivity () {
      this.loading = true
      ++this.page
      this.$store.dispatch(ACTIVITY_GET, {
        model: 'accounts',
        modelId: this.account.id,
        paginate: this.perPage,
        page: this.page
      }).then(response => {
        this.accountActivity.push(...response.data)
        if (response.meta.to === response.meta.total) {
          this.hasMore = false
        } else {
          this.hasMore = true
        }
      }).finally(() => {
        this.loading = false
        this.initialized = true
      })
    },

    addActivity () {
      this.$store.dispatch(ACTIVITY_GET, {
        model: 'accounts',
        modelId: this.account.id,
        paginate: 1
      }).then(response => {
        this.accountActivity.unshift(...response.data)
      })
    }

  }

}
</script>



// WEBPACK FOOTER //
// src/components/Account/RecentActivity.vue